import styled from '@emotion/styled';

import IconCheckCircle from 'components/icons/checkCircle';

import { ItemName } from '../styles';

export const StyledItemName = styled(ItemName)((props) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
}));

export const CheckIcon = styled(IconCheckCircle)((props) => ({
  overflow: 'visible',
  color: props.theme.colors.secondary,
}));
